import React from 'react';
import { Phone, MapPin, Navigation, Facebook } from 'lucide-react';
import { RESTAURANT, HOURS } from '../mock';

export default function Reservation() {
  return (
    <section id="kontakt" className="relative py-24 md:py-32 px-6 md:px-10 bg-[#17130f]">
      <div className="max-w-[1400px] mx-auto">
        <div className="reveal max-w-3xl mb-14">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 bg-[rgba(224,180,159,0.6)]" />
            <span className="eyebrow">05 — Reservierung</span>
          </div>
          <h2 className="font-serif-display font-medium text-[#f2ebe3] text-4xl md:text-6xl leading-[1.05]">
            Ihr Tisch <span className="italic text-[#e0b49f]">wartet</span> schon.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Call card */}
          <div className="reveal rounded-2xl border border-[rgba(224,180,159,0.2)] bg-[#1c1712] p-9 flex flex-col">
            <span className="inline-flex items-center gap-2 self-start text-xs uppercase tracking-[0.16em] text-[#e0b49f] bg-[rgba(224,180,159,0.12)] px-3 py-1.5 rounded-full">
              <span className="h-1.5 w-1.5 rounded-full bg-[#e0b49f]" /> Öffnungszeiten im Überblick
            </span>
            <a
              href={RESTAURANT.phoneHref}
              className="mt-6 font-serif-display text-[#f2ebe3] text-3xl md:text-4xl hover:text-[#e0b49f] transition-colors break-words"
            >
              {RESTAURANT.phone}
            </a>
            <p className="mt-3 text-[#a99a8b] leading-relaxed">
              Reservieren Sie telefonisch oder bequem über Facebook.
            </p>
            <div className="mt-auto pt-8 flex flex-wrap gap-3">
              <a
                href={RESTAURANT.phoneHref}
                className="inline-flex items-center gap-2.5 bg-[#e0b49f] text-[#1a1410] px-6 py-3 rounded-full font-medium hover:bg-[#eac6b3] transition-colors"
              >
                <Phone size={16} /> Anrufen
              </a>
              <a
                href={RESTAURANT.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 bg-[#1877F2] text-white px-6 py-3 rounded-full font-medium hover:bg-[#3b8cf5] transition-colors"
              >
                <Facebook size={16} /> Über Facebook
              </a>
            </div>
          </div>

          {/* Opening hours */}
          <div className="reveal rounded-2xl border border-[rgba(224,180,159,0.2)] bg-[#1c1712] p-9">
            <h3 className="font-serif-display text-2xl text-[#e0b49f] mb-6">Öffnungszeiten</h3>
            <ul className="space-y-3">
              {HOURS.map((h) => (
                <li
                  key={h.day}
                  className={`flex items-center justify-between text-sm border-b border-[rgba(224,180,159,0.1)] pb-3 ${
                    h.today ? 'text-[#e0b49f]' : 'text-[#c3b7aa]'
                  }`}
                >
                  <span className="flex items-center gap-2">
                    {h.day}
                    {h.today && (
                      <span className="text-[10px] uppercase tracking-wider bg-[rgba(224,180,159,0.15)] px-2 py-0.5 rounded-full">Heute</span>
                    )}
                  </span>
                  <span className={h.closed ? 'text-[#8a7d70]' : ''}>{h.time}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Directions */}
          <div className="reveal rounded-2xl border border-[rgba(224,180,159,0.2)] bg-[#1c1712] p-9 flex flex-col">
            <h3 className="font-serif-display text-2xl text-[#e0b49f] mb-6">Anfahrt</h3>
            <div className="flex items-start gap-3 text-[#f2ebe3]">
              <MapPin size={18} className="text-[#e0b49f] mt-0.5 shrink-0" />
              <span className="leading-relaxed">{RESTAURANT.address}</span>
            </div>
            <p className="mt-4 text-[#a99a8b] text-sm leading-relaxed">
              Mitten in der Heidecker Altstadt gelegen – nur wenige Gehminuten vom Marktplatz entfernt. Parkmöglichkeiten finden Sie in der direkten Umgebung.
            </p>
            <div className="mt-auto pt-8 flex flex-wrap gap-3">
              <a
                href={RESTAURANT.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#e0b49f] text-[#1a1410] px-5 py-3 rounded-full font-medium hover:bg-[#eac6b3] transition-colors"
              >
                <Navigation size={15} /> Route planen
              </a>
              <a
                href={RESTAURANT.phoneHref}
                className="inline-flex items-center gap-2 border border-[rgba(224,180,159,0.4)] text-[#f2ebe3] px-5 py-3 rounded-full font-medium hover:border-[#e0b49f] hover:text-[#e0b49f] transition-colors"
              >
                <Phone size={15} /> Anrufen
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
